import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { storage } from '../firebase';

/**
 * Upload une image vers Firebase Storage et retourne son URL.
 * @param file Le fichier image à uploader
 * @param path Le chemin complet de destination (ex: "workshops/images/atelier123.jpg")
 * @returns L’URL publique de l’image uploadée
 */
export const uploadImage = async (
  file: File,
  path: string
): Promise<string> => {
  try {
    const storageRef = ref(storage, path);
    await uploadBytes(storageRef, file);
    const url = await getDownloadURL(storageRef);
    return url;
  } catch (error) {
    console.error('❌ Erreur upload image :', error);
    throw error;
  }
};
